import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faFilter } from '@fortawesome/free-solid-svg-icons';
import * as S from './styles';

interface FiltrosProps {
  aberto: boolean;
  onToggle: () => void;
  /** Filtros ativos, mostrados quando a secao esta fechada. */
  badges?: string[];
  titulo?: string;
  children: React.ReactNode;
}

/**
 * Secao de filtros colapsavel do padrao de UX.
 *
 * Fechada, ela devolve a tela para o resultado -- mas continua dizendo o que
 * esta filtrado, pelas badges. Sem isso o usuario ve uma lista curta e nao
 * sabe se e o dado que acabou ou o filtro que cortou.
 *
 * Os campos sao DESMONTADOS quando fechada, e nao apenas escondidos por CSS:
 * campo invisivel continua recebendo foco pelo Tab e continua sendo lido por
 * leitor de tela.
 */
const Filtros: React.FC<FiltrosProps> = ({
  aberto,
  onToggle,
  badges = [],
  titulo = 'Filtros',
  children,
}) => (
  <S.Secao>
    <S.Cabecalho type="button" onClick={onToggle} aria-expanded={aberto}>
      <FontAwesomeIcon icon={faFilter} />
      <span>{titulo}</span>
      {!aberto && badges.length > 0 && (
        <S.Badges>
          {badges.map((badge) => (
            <S.Badge key={badge}>{badge}</S.Badge>
          ))}
        </S.Badges>
      )}
      <S.Chevron aberto={aberto}>
        <FontAwesomeIcon icon={faChevronDown} />
      </S.Chevron>
    </S.Cabecalho>

    {aberto && <S.Corpo>{children}</S.Corpo>}
  </S.Secao>
);

export default Filtros;
